import { createRouter, createWebHistory } from 'vue-router';
import { usePageDataBaseStore } from '@marso2/frontend-shared-components/src/stores/pageDataBase.js';
import { usePageDataCatalogStore } from '@marso2/frontend-shared-components/src/stores/pageDataCatalog.js';
import { useGlobalStore } from '@marso2/frontend-shared-components/src/stores/global.js';
import { useNewStore } from '@marso2/frontend-shared-components/src/stores/new.js';
import { useInfoStore } from '@marso2/frontend-shared-components/src/stores/info.js';
import { useEventStore } from '@marso2/frontend-shared-components/src/stores/event.js';
import { useSaleStore } from '@marso2/frontend-shared-components/src/stores/sale.js';
import { useMessageStore } from '@marso2/frontend-shared-components/src/stores/message.js';
import { useHelpStore } from '@marso2/frontend-shared-components/src/stores/help.js';

const router = createRouter({
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    if (to.path === from.path) {
      return false;
    }
    return { left: 0, top: 0 };
  },
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/:organizationCode(ru|ru1|ru2|ru3|kg|kz|pp)?/',
      name: 'home',
      component: () => import('../views/HomeView.vue'),
    },
    {
      path: '/:organizationCode(ru|ru1|ru2|ru3|kg|kz|pp)?/auth',
      name: 'auth',
      component: () => import('../views/AuthView.vue'),
      meta: {
        title: 'Авторизация',
      },
    },
    {
      path: '/:organizationCode(ru|ru1|ru2|ru3|kg|kz|pp)?/auth/confirm/:referralId/:confirmCode',
      name: 'auth-confirm',
      component: () => import('../views/AuthView.vue'),
      meta: {
        title: 'Авторизация',
      },
    },
    {
      path: '/:organizationCode(ru|ru1|ru2|ru3|kg|kz|pp)?/catalog/element/:id',
      name: 'catalog-element',
      component: () => import('../views/CatalogElement.vue'),
      meta: { isCatalogElement: true }
    },
    {
      path: '/:organizationCode(ru|ru1|ru2|ru3|kg|kz|pp)?/catalog',
      name: 'catalog-root',
      component: () => import('../views/CatalogView.vue'),
      meta: { isCatalog: true }
    },
    {
      path: '/:organizationCode(ru|ru1|ru2|ru3|kg|kz|pp)?/catalog/:sectionCode',
      name: 'catalog-section',
      component: () => import('../views/CatalogView.vue'),
      meta: { isCatalog: true }
    },
    {
      path: '/:organizationCode(ru|ru1|ru2|ru3|kg|kz|pp)?/catalog/search',
      name: 'catalog-search',
      component: () => import('../views/CatalogView.vue'),
      meta: { isCatalog: true }
    },
    {
      path: '/:organizationCode(ru|ru1|ru2|ru3|kg|kz|pp)?/catalog/search/:sectionCode',
      name: 'catalog-search-section',
      component: () => import('../views/CatalogView.vue'),
      meta: { isCatalog: true }
    },
    {
      path: '/:organizationCode(ru|ru1|ru2|ru3|kg|kz|pp)?/catalog/favorite',
      name: 'catalog-favorite-root',
      component: () => import('../views/CatalogFavoriteView.vue'),
      meta: { isCatalogFavorite: true }
    },
    {
      path: '/:organizationCode(ru|ru1|ru2|ru3|kg|kz|pp)?/catalog/favorite/:sectionCode',
      name: 'catalog-favorite-section',
      component: () => import('../views/CatalogFavoriteView.vue'),
      meta: { isCatalogFavorite: true }
    },
    {
      path: '/:organizationCode(ru|ru1|ru2|ru3|kg|kz|pp)?/basket',
      name: 'basket',
      component: () => import('../views/BasketView.vue'),
      meta: {
        title: 'Корзина',
      },
    },
    {
      path: '/:organizationCode(ru|ru1|ru2|ru3|kg|kz|pp)?/order',
      name: 'order',
      component: () => import('../views/OrderView.vue'),
      meta: {
        title: 'Оформление заказа',
      },
    },
    {
      path: '/:organizationCode(ru|ru1|ru2|ru3|kg|kz|pp)?/payment/:id',
      name: 'payment',
      component: () => import('../views/OrderPaymentView.vue'),
      meta: {
        title: 'Заказ сформирован',
      },
    },
    {
      path: '/:organizationCode(ru|ru1|ru2|ru3|kg|kz|pp)?/payment-result/:id',
      name: 'payment-result',
      component: () => import('../views/OrderPaymentResultView.vue'),
      meta: {
        title: 'Результат оплаты',
      },
    },
    {
      path: '/:organizationCode(ru|ru1|ru2|ru3|kg|kz|pp)?/company',
      name: 'company-main',
      component: () => import('../views/CompanyMain.vue')
    },
    {
      path: '/:organizationCode(ru|ru1|ru2|ru3|kg|kz|pp)?/company/contacts',
      name: 'company-contacts',
      component: () => import('../views/CompanyContacts.vue'),
      meta: {
        title: 'Контакты',
      },
    },
    {
      path: '/:organizationCode(ru|ru1|ru2|ru3|kg|kz|pp)?/company/news',
      name: 'company-news',
      component: () => import('../views/CompanyNews.vue'),
      meta: {
        title: 'Новости',
      },
    },
    {
      path: '/:organizationCode(ru|ru1|ru2|ru3|kg|kz|pp)?/company/news/:code',
      name: 'company-new',
      component: () => import('../views/CompanyNew.vue'),
      meta: {
        isCompanyNew: true,
      },
    },
    {
      path: '/:organizationCode(ru|ru1|ru2|ru3|kg|kz|pp)?/sale',
      name: 'sales',
      component: () => import('../views/SalesView.vue'),
      meta: {
        title: 'Акции',
      },
    },
    {
      path: '/:organizationCode(ru|ru1|ru2|ru3|kg|kz|pp)?/sale/:code',
      name: 'sale',
      component: () => import('../views/SaleView.vue'),
      meta: {
        isSale: true,
      },
    },
    {
      path: '/:organizationCode(ru|ru1|ru2|ru3|kg|kz|pp)?/company/franchise',
      name: 'company-franchise',
      component: () => import('../views/CompanyFranchise.vue')
    },
    {
      path: '/:organizationCode(ru|ru1|ru2|ru3|kg|kz|pp)?/registration/request',
      name: 'registration-request',
      component: () => import('../views/RegistrationRequest.vue')
    },
    {
      path: '/:organizationCode(ru|ru1|ru2|ru3|kg|kz|pp)?/help/:code',
      name: 'help',
      component: () => import('../views/Help.vue'),
      meta: {
        isHelp: true,
      },
    },
    {
      path: '/:organizationCode(ru|ru1|ru2|ru3|kg|kz|pp)?/auth/registration/:referralCode?',
      name: 'auth-registration',
      component: () => import('../views/AuthRegistration.vue'),
      meta: {
        title: 'Регистрация',
      },
    },
    {
      path: '/:organizationCode(ru|ru1|ru2|ru3|kg|kz|pp)?/registration/:referralCode',
      name: 'auth-registration-referral',
      component: () => import('../views/AuthRegistration.vue'),
      meta: {
        title: 'Регистрация',
      },
    },
    {
      path: '/:organizationCode(ru|ru1|ru2|ru3|kg|kz|pp)?/auth/referral/:referralId?',
      name: 'auth-registration-referral2',
      component: () => import('../views/AuthRegistration.vue'),
      meta: {
        title: 'Регистрация',
      },
    },
    {
      path: '/:organizationCode(ru|ru1|ru2|ru3|kg|kz|pp)?/auth/change-password/:referralId/:confirmCode',
      name: 'auth-change-password',
      component: () => import('../views/AuthChangePassword.vue'),
      meta: {
        title: 'Сменить пароль',
      },
    },
    {
      path: '/:organizationCode(ru|ru1|ru2|ru3|kg|kz|pp)?/personal',
      name: 'personal',
      component: () => import('../views/PersonalView.vue'),
      meta: {
        requiresAuth: true,
        title: 'Мой кабинет',
      },
    },
    {
      path: '/:organizationCode(ru|ru1|ru2|ru3|kg|kz|pp)?/personal/change-password',
      name: 'personal-change-password',
      component: () => import('../views/AuthChangePassword.vue'),
      meta: {
        requiresAuth: true,
        title: 'Сменить пароль',
      },
    },
    {
      path: '/:organizationCode(ru|ru1|ru2|ru3|kg|kz|pp)?/personal/accounts',
      name: 'personal-accounts',
      component: () => import('../views/PersonalAccountsView.vue'),
      meta: {
        requiresAuth: true,
        title: 'Мои счета',
      },
    },
    {
      path: '/:organizationCode(ru|ru1|ru2|ru3|kg|kz|pp)?/personal/network',
      name: 'personal-network',
      component: () => import('../views/PersonalNetworkView.vue'),
      meta: {
        requiresAuth: true,
        title: 'Дерево',
      },
    },
    {
      path: '/:organizationCode(ru|ru1|ru2|ru3|kg|kz|pp)?/personal/network2',
      name: 'personal-network2',
      component: () => import('../views/PersonalNetwork2View.vue'),
      meta: {
        requiresAuth: true,
        title: 'Детализация линии',
      },
    },
    {
      path: '/:organizationCode(ru|ru1|ru2|ru3|kg|kz|pp)?/personal/message/',
      name: 'personal-message',
      component: () => import('../views/PersonalMessageView.vue'),
      meta: {
        requiresAuth: true,
        title: 'Уведомления',
      },
    },
    {
      path: '/:organizationCode(ru|ru1|ru2|ru3|kg|kz|pp)?/personal/message/:id',
      name: 'personal-message-item',
      component: () => import('../views/PersonalMessageItem.vue'),
      meta: {
        isMessageItem: true,
      },
    },
    {
      path: '/:organizationCode(ru|ru1|ru2|ru3|kg|kz|pp)?/personal/education',
      name: 'personal-education',
      component: () => import('../views/PersonalEducationView.vue'),
      meta: {
        requiresAuth: true,
        title: 'Обучение',
      },
    },
    {
      path: '/:organizationCode(ru|ru1|ru2|ru3|kg|kz|pp)?/personal/orders',
      name: 'personal-orders',
      component: () => import('../views/PersonalOrdersView.vue'),
      meta: {
        requiresAuth: true,
        title: 'Мои заказы',
      },
    },
    {
      path: '/:organizationCode(ru|ru1|ru2|ru3|kg|kz|pp)?/personal/orders/:id',
      name: 'personal-orders-detail',
      component: () => import('../views/PersonalOrdersDetailView.vue'),
      meta: {
        requiresAuth: true,
        title: 'Мои заказы',
      },
    },
    {
      path: '/:organizationCode(ru|ru1|ru2|ru3|kg|kz|pp)?/personal/travels',
      name: 'personal-travels',
      component: () => import('../views/PersonalTravelsView.vue'),
      meta: {
        requiresAuth: true,
        title: 'Путешествия с компанией',
      },
    },
    {
      path: '/:organizationCode(ru|ru1|ru2|ru3|kg|kz|pp)?/personal/tickets',
      name: 'personal-tickets',
      component: () => import('../views/PersonalTickets.vue'),
      meta: {
        requiresAuth: true,
        title: 'Билеты',
      },
    },
    {
      path: '/:organizationCode(ru|ru1|ru2|ru3|kg|kz|pp)?/personal/lottery',
      name: 'personal-lottery',
      component: () => import('../views/PersonalLotteryTickets.vue'),
      meta: {
        requiresAuth: true,
        title: 'Лотерея',
      },
    },
    {
      path: '/:organizationCode(ru|ru1|ru2|ru3|kg|kz|pp)?/personal/verification',
      name: 'personal-verification',
      component: () => import('../views/PersonalVerification.vue'),
      meta: {
        requiresAuth: true,
        title: 'Верификация',
      },
    },
    {
      path: '/:organizationCode(ru|ru1|ru2|ru3|kg|kz|pp)?/personal/tickets/:id',
      name: 'personal-ticket',
      component: () => import('../views/PersonalTicket.vue'),
      meta: {
        requiresAuth: true,
        title: 'Билеты',
      },
    },
    {
      path: '/:organizationCode(ru|ru1|ru2|ru3|kg|kz|pp)?/info/:code',
      name: 'info-code',
      component: () => import('../views/InfoView.vue'),
      meta: {
        isInfo: true,
      },
    },
    {
      path: '/:organizationCode(ru|ru1|ru2|ru3|kg|kz|pp)?/info',
      name: 'info-main',
      component: () => import('../views/InfoView.vue'),
      meta: {
        title: 'Справочная информация',
      },
    },
    {
      path: '/:organizationCode(ru|ru1|ru2|ru3|kg|kz|pp)?/privileges',
      name: 'privileges',
      component: () => import('../views/InfoView.vue'),
      meta: {
        isPrivileges: true,
      },
    },
    {
      path: '/:organizationCode(ru|ru1|ru2|ru3|kg|kz|pp)?/events',
      name: 'events',
      component: () => import('../views/Events.vue')
    },
    {
      path: '/:organizationCode(ru|ru1|ru2|ru3|kg|kz|pp)?/events/:code',
      name: 'event',
      component: () => import('../views/EventView.vue'),
      meta: {
        isEvent: true,
      },
    },
    {
      path: '/:organizationCode(ru|ru1|ru2|ru3|kg|kz|pp)?/join-us',
      name: 'join-us',
      component: () => import('../views/JoinUsView.vue'),
      meta: {
        title: 'Измени свою жизнь к лучшему!',
      },
    },
    {
      path: '/:organizationCode(ru|ru1|ru2|ru3|kg|kz|pp)?/marketing-plan',
      name: 'marketing-plan',
      component: () => import('../views/MarketingPlanView.vue'),
      meta: {
        isMarketingPlan: true,
        withoutDefaultLayout: true,
        title: 'Маркетинг-план'
      }
    },
    {
      path: '/:organizationCode(ru|ru1|ru2|ru3|kg|kz|pp)?/:pathMatch(.*)*',
      name: 'not-found',
      component: () => import('../views/ErrorView.vue'),
      meta: {
        title: 'Страница не найдена'
      }
    }
  ],
});

router.beforeEach(async (to, from, next) => {
  const pageDataBaseStore = usePageDataBaseStore();
  const globalStore = useGlobalStore();
  const pageDataCatalogStore = usePageDataCatalogStore();
  pageDataBaseStore.isLoaded = to.params.organizationCode === from.params.organizationCode && from.params.organizationCode === globalStore.organizationCode;
  pageDataCatalogStore.isLoaded = pageDataBaseStore.isLoaded;
  next();
});

router.beforeResolve(async (to, from, next) => {
  const pageDataBaseStore = usePageDataBaseStore();
  const globalStore = useGlobalStore();
  const newStore = useNewStore();
  const saleStore = useSaleStore();
  const infoStore = useInfoStore();
  const eventStore = useEventStore();
  const messageStore = useMessageStore();
  const helpStore = useHelpStore();
  const orgsRu = ['', 'ru', 'ru1', 'ru2', 'ru3', 'pp'];
  const isToRu = orgsRu.includes(to.params.organizationCode);
  const isFromRu = orgsRu.includes(from.params.organizationCode);
  const isLoadedWarehouses = isToRu && isFromRu;

  const originalTempAuthReferralId = router._tempAuthReferralId;
  router._tempAuthReferralId = to.query.authReferralId;

  try {
    if (!pageDataBaseStore.isUpdating) {
      if ((!pageDataBaseStore.isLoaded)) {
        await pageDataBaseStore.updatePageDataBase(to.params.organizationCode, to.query.order_token);
        if (!isLoadedWarehouses) await globalStore.updateWarehouses();
      } else {
        globalStore.loading = false;
      }
    } else {
      globalStore.loading = false;
    }
    const defaultTitle = 'Marso - магазин парфюма';
    document.title = to.meta.title ? `${to.meta.title}` : defaultTitle;

    if (to.meta.isHelp) {
      document.title = `Помощь`;
      if (!newStore.isLoaded && to.params.code !== 'sertifikaty') {
        await helpStore.updateHelp(to.params.code);
      }
    }

    if (to.meta.isCompanyNew) {
      if (!newStore.isLoaded) {
        await newStore.updateNew(to.params.code);
        document.title = `${newStore.item.name}`;
      }
    }

    if (to.meta.isMessageItem) {
      if (!messageStore.isLoaded) {
        await messageStore.updateMessage(to.params.id);
        document.title = `${messageStore.item.title}`;
      }
    }

    if (to.meta.isSale) {
      if (!saleStore.isLoaded) {
        await saleStore.updateSale(to.params.code);
        document.title = `${saleStore.item.name}`;
      }
    }

    if (to.meta.isInfo) {
      if (to.params.code === 'requisites') {
        document.title = 'Наши реквизиты';
      }
      if (to.params.code === 'cookie-notice-faq') {
        document.title = 'Политика использования файлов Сookie';
      }
      if (!infoStore.isLoaded && to.params.code !== 'requisites' && to.params.code !== 'cookie-notice-faq') {
        await infoStore.updateInfo(to.params.code);
        document.title = `${infoStore.item.name}`;
      }
    }

    if (to.meta.isPrivileges) {
      if (!infoStore.isLoaded) {
        await infoStore.updateInfo('privileges');
        document.title = `${infoStore.item.name}`;
      }
    }

    if (to.meta.isEvent) {
      if (!eventStore.isLoaded) {
        await eventStore.updateEvent(to.params.code);
        document.title = `${eventStore.item.name}`;
      }
    }

    const authPages = ['auth', 'auth-confirm', 'auth-registration', 'auth-registration-referral', 'auth-change-password', 'registration-request'];
    if (authPages.includes(to.name) && pageDataBaseStore.isAuthorized) {
      return next({ name: 'personal', params: { organizationCode: to.params.organizationCode } });
    }

    if (to.meta.requiresAuth && !pageDataBaseStore.isAuthorized) {
      return next({ name: 'auth', params: { organizationCode: to.params.organizationCode } });
    }

    if (to.params.organizationCode !== globalStore.canonicalOrganizationCode) {
      return next({
        name: to.name,
        params: { ...to.params, organizationCode: globalStore.canonicalOrganizationCode },
        query: to.query,
        replace: true
      });
    }
    next();
  } finally {
    router._tempAuthReferralId = originalTempAuthReferralId;
  }
});

export default router;
